
export class SourceObjectFilterOptions {
    sourceObjectIds: Array<number>;
    platformIds: Array<number>;
    dataSetIds: Array<number>;
    dataOwnerIds: Array<number>;
}
